// 9fbef606107a605d69c0edbcd8029e5d
import { dyPageGroups, dyPageTypes, dyPageNames } from './constants';

export const getPDPContext = (payload = {}) => {
  return {
    groups: dyPageGroups.PDP,
    pageType: dyPageTypes.PDP,
    pageName: dyPageNames.PDP,
    ...payload,
  };
};

export const getCartContext = (payload = {}) => {
  return {
    groups: dyPageGroups.CART,
    pageType: dyPageTypes.CART,
    pageName: dyPageNames.CART,
    ...payload,
  };
};

export const getATBContext = (payload = {}) => {
  return {
    groups: dyPageGroups.ATB,
    pageType: dyPageTypes.PDP,
    pageName: dyPageNames.ATB,
    ...payload,
  };
};

export const getOrderContext = (payload = {}) => {
  return {
    groups: dyPageGroups.ORDER,
    pageType: dyPageTypes.CART,
    pageName: dyPageNames.ORDER,
    ...payload,
  };
};

export const getHomepageContext = (payload = {}) => {
  return {
    groups: dyPageGroups.HOME,
    pageType: dyPageTypes.HOME,
    pageName: dyPageNames.HOME,
    ...payload,
  };
};
